<template>
	<div>

		<div class="plans d-flex flex-wrap">
			<v-card
				v-for="plan in plans"
				:key="plan.id"
				class="mx-auto"
				max-width="344"
				text-center
			>
				<v-card-text class="text-center">
					<div class="text-h3 text-center mb-5">
						{{ plan.title }}
					</div>
					<p class="mb-5">
						{{ plan.description }}
					</p>
					<div class="text--primary">
						{{ plan.price }} ש"ח
					</div>
				</v-card-text>
				<v-card-actions>
					<v-btn
						:to="{name:'plan-edit', params:{planId:plan.id}}"
						depressed
						color="primary"
					>
						עריכה
					</v-btn>
					<v-btn
						depressed
						@click="deletePlan(plan)"
					>
						מחיקה
					</v-btn>
				</v-card-actions>
			</v-card>
		</div>
	</div>
</template>

<script>

import PlanModule from "@/store/modules/Plan.module";

export default {
	name: "PlansDisplay",
	props: { plans: Array },
	data: function () {
		return {};
	},
	computed: {},
	created () {

	},
	methods: {
		editPlanLink (id) {
			return "/plan/edit/" + id;
		},
		deletePlan (plan) {
			this.$notfication.warning().then((data) => {
				if (data.isConfirmed) {
					this.$store.dispatch(PlanModule.types.REMOVE, plan).then((response) => {
						this.$notfication.success();
					});
				}
			});
		},
	},

};
</script>
